<template>
    <div class="btn-box" ref="draggableEl"
        :style="{
            right: position.x + 'px',
            bottom: position.y + 'px'
        }"
        @touchstart="startDrag"
    >
        <div class="back-btn" @click="backHome">
            <Icon name="home-o" />
        </div>
        <div class="back-btn" @click="backUp">
            <Icon name="revoke" />
        </div>
    </div>
</template>
<script>
import { Icon } from 'vant';
export default {
    name: 'backBtn',
    components: { Icon },
    data() {
        return {
            position: {
                x: 20,
                y: 120
            },
            isDragging: false,
            startPos: {
                x: 0,
                y: 0
            }
        }
    },
    methods: {
        backHome(){
            this.$router.push({path: '/indexPageNew'})
        },
        backUp(){
            this.$router.back()
        },
        startDrag(e) {
            e.stopPropagation()
            this.isDragging = true
            // 记录鼠标按下时的初始位置和元素当前位置
            this.startPos = {
                y: e.touches[0].clientY
            }
            document.addEventListener('touchmove', this.onDrag)
            document.addEventListener('touchend', this.stopDrag)

        },
        onDrag(e) {
            if (!this.isDragging) return
            // 计算新位置：当前鼠标位置减去初始偏移量
            const newY = e.touches[0].clientY - this.startPos.y
            this.startPos.y = e.touches[0].clientY
            
            this.position = {
                y: this.position.y - newY
            }
        },
        stopDrag() {
            this.isDragging = false
            document.removeEventListener('touchmove', this.onDrag)
            document.removeEventListener('touchend', this.stopDrag)
        }
    },
    beforeDestroy() {
        document.removeEventListener('touchmove', this.onDrag)
        document.removeEventListener('touchend', this.stopDrag)
    }
}
</script>
<style>
.btn-box {
    position: fixed;
}
.back-btn {
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 12px;
    box-shadow: 0px 0.06rem 0.6rem 0px rgb(153 153 153 / 50%);
    border-radius: 50%;
    background: #fff;
}
</style>
